import React from "react";
import { Mars, Venus, CircleUser } from "lucide-react";

// Muestra un pequeño icono coloreado según el género del participante.
// Diseñado para alinearse al lado del nombre en tablas y chips.
// Estilo pill sólido: fuerte contraste M/F para localizar de un vistazo.
export default function GenderIcon({ gender, size = 14, className = "" }) {
  if (gender === "male") {
    return (
      <span
        title="Hombre"
        className={`inline-flex items-center justify-center rounded-full bg-sky-500 text-white shadow-sm ring-1 ring-sky-600/20 ${className}`}
        style={{ width: size + 10, height: size + 10 }}
        data-testid="gender-male"
      >
        <Mars size={size} strokeWidth={3} />
      </span>
    );
  }
  if (gender === "female") {
    return (
      <span
        title="Mujer"
        className={`inline-flex items-center justify-center rounded-full bg-pink-500 text-white shadow-sm ring-1 ring-pink-600/20 ${className}`}
        style={{ width: size + 10, height: size + 10 }}
        data-testid="gender-female"
      >
        <Venus size={size} strokeWidth={3} />
      </span>
    );
  }
  return (
    <span
      title="Sin especificar"
      className={`inline-flex items-center justify-center rounded-full bg-slate-200 text-slate-500 dark:bg-slate-700 dark:text-slate-400 ${className}`}
      style={{ width: size + 10, height: size + 10 }}
      data-testid="gender-unspecified"
    >
      <CircleUser size={size} strokeWidth={2} />
    </span>
  );
}
